import { AppState } from '@core/state';
import { createChildSelectors } from '@util/lib/ngrx-child-selectors';

import { initialState } from './inventory.reducers';

export const selectInventoryState = (state: AppState) => state.inventory;

export const { selectDetail, selectLot } = createChildSelectors(selectInventoryState, initialState);

export const { selectData: selectItemDetailData } = createChildSelectors(selectDetail, initialState.detail);
export const { selectData: selectLotDetailData } = createChildSelectors(selectLot, initialState.lot);
